import axios from 'axios';
import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { Navigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Protec from '../../assets/Images/protec.svg';

import './Login.scss';

const Login = () => {
  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [isInvalid, setIsInvalid] = useState(false);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    axios
      .get('/api/account/', { withCredentials: true })
      .then((response: any) => {
        setIsConnected(response.data.connected);
      })
      .catch((err) => {
        setIsConnected(false);
      });
  }, []);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();
    axios
      .post('/api/account/login', {
        email: username,
        password,
      })
      .then((response: any) => {
        if (response.status === 200) {
          setIsConnected(true);
          setIsInvalid(false);
        }
      })
      .catch((err) => {
        toast.error(err.response?.data?.message ?? err.response?.data ?? 'Unable to sign in');
        setIsConnected(false);
        setIsInvalid(true);
      })
      .finally(() => {
        setUsername('');
        setPassword('');
      });
  };

  return (
    <main className="login-page">
      {isConnected && <Navigate to="/" />}
      <Container fluid className="login-page__shell">
        <Row className="login-page__layout g-0">
          <Col lg={6} className="login-page__brand">
            <div className="login-page__brand-content">
              <div className="login-page__logo-wrap">
                <img src={Protec} alt="Protection Civile" className="login-page__logo" />
              </div>
              <span className="login-page__eyebrow">Protection Civile · Loire-Atlantique</span>
              <h1>
                Le terrain,
                <br />
                mieux organisé.
              </h1>
              <p>
                Accédez à votre espace de pilotage pour préparer vos réunions, suivre vos frais et
                coordonner vos activités.
              </p>
              <div className="login-page__signal">
                <span /> Service interne sécurisé
              </div>
            </div>
          </Col>
          <Col lg={6} className="login-page__form-side">
            <div className="login-page__form-wrap">
              <span className="login-page__form-kicker">Espace adhérent</span>
              <h2>Bienvenue sur Protec'App</h2>
              <p className="login-page__form-intro">Connectez-vous pour continuer.</p>
              <Form onSubmit={handleSubmit} className="login-page__form">
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="username">Adresse email</Form.Label>
                  <Form.Control
                    id="username"
                    name="username"
                    type="email"
                    autoComplete="username"
                    value={username}
                    onChange={(e) => {
                      setUsername(e.target.value);
                      setIsInvalid(false);
                    }}
                    isInvalid={isInvalid}
                    placeholder="vous@exemple.fr"
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-4">
                  <div className="d-flex justify-content-between">
                    <Form.Label htmlFor="password">Mot de passe</Form.Label>
                  </div>
                  <Form.Control
                    id="password"
                    name="password"
                    type="password"
                    autoComplete="current-password"
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setIsInvalid(false);
                    }}
                    isInvalid={isInvalid}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    Identifiants invalides
                  </Form.Control.Feedback>
                </Form.Group>
                <Button variant="primary" type="submit" className="login-page__submit w-100">
                  Se connecter <span aria-hidden="true">→</span>
                </Button>
              </Form>
              <p className="login-page__legal">
                Accès réservé aux personnes habilitées.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </main>
  );
};

export default Login;
